import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import DspLandingPageMgmt from './components/DspLandingPageMgmt';

export default function DspLandingPagePage() {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Amazon DSP Landing Pages</h3>
        </Col>
      </Row>
      <Row>
        <DspLandingPageMgmt />
      </Row>
    </Container>
  );
}
